export const DISMISSED_COOKIE = "pwa_install_banner_dismissed";
